module.exports = __webpack_public_path__ + "img/a47cb2e.jpg";